import i18next from "i18next";
import { openNotificationPopup, openSuccessAlert } from "state/application/applicationSlice";

export async function handleUpdateAsset(
  actionFunction,
  communityId,
  assetId,
  newAsset,
  dispatch,
  message
) {
  try {
    await actionFunction({ communityId, assetId, newAsset }).unwrap();

    const description = message ?? i18next.t("common:operation_success");

    dispatch(
      openSuccessAlert({
        title: i18next.t("common:updated"),
        description,
      })
    );

    return true;
  } catch (err) {
    dispatch(
      openNotificationPopup({
        notification: err,
        type: "error",
      })
    );

    return false;
  }
}

export default {
  handleUpdateAsset,
};
